<div class="correction-partial">
  <ng-container *ngIf="showInsured">
    <correction-form personType="insured" (toggle)="submitCorrection()"></correction-form>
  </ng-container>
  <ng-container *ngIf="showOwner">
    <correction-form personType="owner" (toggle)="submitCorrection()"></correction-form>
  </ng-container>
</div>
